<template>
  <div class="order-page">
    <!-- <div class="back" @click="$router.back()">
      返回
    </div>-->
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-top: 10px"
    >
      <el-breadcrumb-item :to="{ path: '/user/home' }"
        >个人中心</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/user/order' }"
        >我的订单</el-breadcrumb-item
      >
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="status-box">
      <div class="first">
        <span>订单：{{ $route.query.id }}</span>
        <div style="margin-top: 8px;">
          <el-tag class="imm" :class="'state'+(orderData.orderStatus || 0)">
            {{ orderData.orderStatus ? statusList[orderData.orderStatus] : "" }}
          </el-tag>
        </div>
      </div>
      <div class="second" v-if="orderData.orderStatus != 6">
        <el-steps
          :space="200"
          :active="Number(orderData.orderStatus)"
          finish-status="success"
          align-center
        >
          <el-step
            v-for="str in statusList.slice(0, 6)"
            :title="str"
            :key="str"
          ></el-step>
        </el-steps>
      </div>
      <div
        class="thrid"
        v-if="orderData.orderStatus != 6 && orderData.orderStatus > 2"
      >
        <div style="img">
          <a href="#">
            <img src="../../assets/pay-process.png" alt />
          </a>
        </div>
        <div class="customer">
          <span>总金额：{{ billCustomer && billCustomer.actualMoney }}</span>
          <span>已付：{{ billCustomer.acceptedMoney }}</span>
          <span style="color: red"
            >待付：{{
              billCustomer.actualMoney - billCustomer.acceptedMoney
            }}</span
          >
          <span style="color: red"
            >到期日：{{ billCustomer.receivablesTime }}</span
          >
        </div>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column align="right" prop="name" label min-width="1">
          <template slot-scope="scope">
            <router-link
              :to="{
                path: `/goodsdetail?id=${scope.row.commodityId}&groupNo=${
                  scope.row.groupNo || ''
                }`,
              }"
            >
              <img
                :src="scope.row.pictureUrl"
                style="max-width: 100px; max-height: 60px; cursor: pointer"
              />
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="commodityName"
          label="商品"
          min-width="3"
        >
          <template slot-scope="scope">
            <router-link
              :to="{
                path: `/goodsdetail?id=${scope.row.commodityId}&groupNo=${
                  scope.row.groupNo || ''
                }`,
              }"
              >{{ scope.row.commodityName }}</router-link
            >
          </template>
        </el-table-column>
        <!-- <el-table-column align="left" prop="commodityName" label="商品"></el-table-column> -->
        <el-table-column
          align="center"
          prop="marketPrice"
          label="市场价(元)"
          min-width="2"
        ></el-table-column>
        <!-- <el-table-column
          align="center"
          prop="discountPrice"
          label="采集价(元)"
          min-width="2"
        ></el-table-column> -->
        <el-table-column
          align="center"
          prop="unit"
          label="数量"
          min-width="2"
        ></el-table-column>
        <el-table-column align="center" label="小计（元）" min-width="2">
          <template slot-scope="scope">
            <p>{{ (scope.row.discountPrice * scope.row.unit).toFixed(2) }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" min-width="2">
          <template slot-scope="scope">
            <div v-if="orderData.orderStatus < 2">
              <el-tag class="state4">待确认</el-tag>
            </div>
            <div v-else-if="orderData.orderStatus == 6">
              <el-tag class="state3">已取消</el-tag>
            </div>
            <div v-else>
              <el-tag>{{goodsStatusList[scope.row.cargoConfirm]}}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="3">
          <template slot-scope="scope">
            <button
              v-if="orderData.orderStatus === '2'"
              class="common-btn"
              @click="choseGoods(scope.row, scope.row.cargoConfirm == 1)"
            >
              替换
            </button>
            <el-popconfirm
              v-if="orderData.orderStatus === '2'"
              title="删除缺货商品？"
              @confirm="removeGoods(scope.row)"
            >
              <button class="common-btn" slot="reference">删除</button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <p style="text-align: right; margin-top: 20px; margin-right: 260px">
        总价：{{ orderData.money }}
      </p>
      <div style="text-align: right; margin-top: 20px">
        <el-popconfirm
          v-if="orderData.status == 9"
          title="确认订单无误？（确认后发货）"
          @confirm="doConfirm(orderData)"
        >
          <button class="common-btn" slot="reference">确认</button>
        </el-popconfirm>
        <button
          class="common-btn"
          slot="reference"
          v-if="orderData.status == 1"
          @click="doConfirm(orderData)"
        >
          提交
        </button>
        <button class="common-btn ppt ppt-1" @click="exportPPT">生成PPT</button>
        <button class="common-btn excel" @click="exportExcel">导出Excel表格</button>
        <el-popconfirm
          v-if="orderData.orderStatus < 3"
          title="确认取消订单？"
          @confirm="cancel"
        >
          <button class="common-btn cancel" slot="reference">取消订单</button>
        </el-popconfirm>
        <button
          class="common-btn"
          @click="reBuy"
          v-if="orderData.orderStatus >= 5"
        >
          再次购买
        </button>
      </div>
      <el-dialog title="替换商品" :visible.sync="switchModal">
        <el-input
          class="input"
          v-model="query.keyword"
          @keyup.enter.native="searchGoods"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="searchGoods"
          ></i>
        </el-input>
        <el-table
          ref="multipleTable"
          :data="switchData"
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            type="selection"
            min-width="5"
          ></el-table-column>
          <el-table-column align="right" prop="name" label min-width="12">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: `/goodsdetail?id=${scope.row.id}&groupNo=${
                    scope.row.groupNo || ''
                  }`,
                }"
              >
                <img
                  :src="scope.row.defaultImage"
                  style="max-width: 100px; max-height: 60px; cursor: pointer"
                />
              </router-link>
            </template>
          </el-table-column>
          <el-table-column align="left" prop="name" label="商品" min-width="20">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: `/goodsdetail?id=${scope.row.id}&groupNo=${
                    scope.row.groupNo || ''
                  }`,
                }"
                >{{ scope.row.name }}</router-link
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="marketPrice"
            label="市场价(元)"
            min-width="10"
          ></el-table-column>
          <!-- <el-table-column
            align="center"
            prop="collectivePrice"
            label="采集价(元)"
            min-width="10"
          ></el-table-column> -->
          <el-table-column
            align="center"
            prop="quantity"
            label="数量"
            min-width="14"
          >
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.quantity"
                :min="1"
                size="small"
                style="width: 120px"
              ></el-input-number>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="text-align: right; margin-top: 12px"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page.sync="query.pageNo"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="query.pageSize"
          layout="sizes, prev, pager, next"
          :total="query.total"
        ></el-pagination>
        <div class="foot">
          <button class="common-btn-primary" @click="confirmSwitch">
            确认
          </button>
          <button class="common-btn" @click="switchModal = false">取消</button>
        </div>
      </el-dialog>
    </div>
    <div class="process-box">
      <div>
        <!-- <div class="img">
          <img src="http://39.99.175.196/kufeng-admin/305168990424416197e668be3cca4cc6.jpg" alt />
          <img src="../../assets/no-picture.png" alt />
        </div>-->
        <p>订单进程</p>
      </div>
      <div class="process-content">
        <div
          :class="{ process: true, suc: item.status }"
          v-for="(item, i) in processData"
          :key="i"
        >
          <p>{{ item.createTime }}</p>
          <div class="bar-box">
            <i class="el-icon-success"></i>
            <div class="bar"></div>
          </div>
          <div v-if="item.url" class="img">
            <a v-if="item.url.includes('pdf')" :href="item.url" target="blank">
              <button style="margin-top: 14px" class="common-btn-text">
                下载PDF
              </button>
            </a>
            <div
              v-else
              v-for="(image, index) in item.url.split(',')"
              :key="index"
            >
              <a :href="image" target="_blank"><img :src="image" /></a>
            </div>
          </div>
          <div class="txt">
            <p>{{ item.title }}</p>
            <p>{{ item.remarks }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="info-box">
      <div>
        <p>收货人信息</p>
        <p>
          <span>收货人：</span>
          <span>{{ address.consignee }}</span>
        </p>
        <p>
          <span>地址：</span>
          <span>{{ address.receivingAddress }}</span>
        </p>
        <p>
          <span>手机号码：</span>
          <span>{{ address.consigneePhone }}</span>
        </p>
      </div>
      <div>
        <p>配送信息</p>
        <!-- <p>
          <span>运费：</span>
          <span>￥{{address.freight}}</span>
        </p>-->
        <p>
          <span>物流公司</span>
          <span>{{ distributionData.logisticsCompany }}</span>
        </p>
        <p>
          <span>物流编号</span>
          <span>{{ distributionData.logisticsNumber }}</span>
        </p>
        <p>
          <span>送货人名字</span>
          <span>{{ distributionData.deliveryName }}</span>
        </p>
        <p>
          <span>送货人电话</span>
          <span>{{ distributionData.deliveryPhone }}</span>
        </p>
        <p>
          <span>备注</span>
          <span>{{ distributionData.remarks }}</span>
        </p>
      </div>
      <div>
        <p>付款信息</p>
        <p>
          <span>付款方式：</span>
          <span>在线支付</span>
        </p>
        <p>
          <span>付款时间：</span>
          <span></span>
        </p>
        <p>
          <span>商品总额：</span>
          <span>￥{{ orderData.money }}</span>
        </p>
        <p>
          <span>应支付金额：</span>
          <span>￥{{ orderData.money }}</span>
        </p>
      </div>
      <div>
        <p>发票信息</p>
        <p>
          <span>发票类型：</span>
          <span>{{
            invoiceData && invoiceData.credentials ? "已开发票" : ""
          }}</span>
        </p>
        <p style="margin-top: 12px">
          <span class="img">
            <!-- 发票图 -->
            <img :src="invoiceData.credentials" alt />
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findSysCommodityOrderByOrderIdForUser,
  findOrderInformationById,
  goodsList,
  findCommodityRecommendCommodityId,
  findBillCustomerByOrderId,
  addCommodityRecommendToCommodityOrder,
  deleteCommodityRecommend,
  findMilepostByOrderId,
  findLogisticsOrder,
  exportExcel,
  exportPPT,
  submission,
  cancelOrder,
} from "@/js/api";
import {
  orderStatusList,
  goodsStatusList
} from "@/js/goods"
export default {
  name: "orderDetail",
  computed: {
    address() {
      return this.tableData[0] || {};
    },
  },
  data() {
    return {
      processData: [
        {
          name: "已验收",
          status: 1,
          time: "2020-1-18",
          img: "http://39.99.175.196/kufeng-admin/305168990424416197e668be3cca4cc6.jpg",
          message: "附加信息",
        },
        {
          name: "派送中",
          status: 0,
          time: "2020-1-20",
          message: "附加信息",
        },
      ],
      distributionData: {},
      invoiceData: {},
      orderData: {},
      billCustomer: {},
      tableData: [],
      query: {
        pageNo: 1,
        pageSize: 6,
        total: 0,
        keyword: "",
      },
      query: {
        pageNo: 1,
        pageSize: 6,
        total: 0,
        keyword: "",
      },
      statusList: orderStatusList,
      goodsStatusList: goodsStatusList,
      isRecommend: true,
      switchModal: false,
      switchData: [],
      switchGood: {},
      multipleSelection: [],
    };
  },
  mounted() {
    this.getData();
    this.getBillCustomer();
    this.getOrderData();
    findMilepostByOrderId({
      orderId: this.$route.query.id,
    }).then((res) => {
      if (res.code == 200) {
        const list = res.result || [];
        this.processData = list;
      } else {
        this.$message.error(res.message);
      }
    });
    // 配送、发票信息
    findLogisticsOrder({
      orderId: this.$route.query.id,
      typeId: 1,
    }).then((res) => {
      if (res.code == 200) {
        this.distributionData = (res.result && res.result[0]) || {};
      } else {
        this.$message.error(res.message);
      }
    });
    findLogisticsOrder({
      orderId: this.$route.query.id,
      typeId: 2,
    }).then((res) => {
      if (res.code == 200) {
        this.invoiceData = (res.result && res.result[0]) || {};
      } else {
        this.$message.error(res.message);
      }
    });
  },
  methods: {
    reBuy() {
      const orderId = this.$route.query.id;
      this.$router.push(`/order/create?orderId=${orderId}`);
    },
    cancel(id) {
      cancelOrder({
        id: this.$route.query.id,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.getOrderData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    doConfirm(item) {
      submission({
        orderId: item.id,
        confirm: 0,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getOrderData();
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getOrderData() {
      findOrderInformationById({
        id: this.$route.query.id,
      }).then((res) => {
        if (res.code == 200) {
          this.orderData = res.result || {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getBillCustomer() {
      findBillCustomerByOrderId({
        orderId: this.$route.query.id,
      }).then((res) => {
        if (res.code == 200) {
          this.billCustomer = res.result || {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getData() {
      findSysCommodityOrderByOrderIdForUser({
        orderId: this.$route.query.id,
      }).then((res) => {
        if (res.code == 200) {
          const list = res.result || [];
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 选择替换商品
    choseGoods(item, isRecommend) {
      this.switchData = [];
      this.switchModal = true;
      this.switchGood = item;
      // 默认推荐商品
      if (isRecommend) {
        findCommodityRecommendCommodityId({
          orderId: this.$route.query.id,
          shortageCommodityId: item.commodityId,
        }).then((res) => {
          if (res.code == 200) {
            this.query.total = res.result.total || res.result.length;
            let tempData = res.result;
            tempData.map((z) => {
              z.quantity = 1;
            });
            this.switchData = tempData;
          }
        });
      } else {
        this.searchGoods();
      }
    },
    // choseGoods(item) {
    //   this.switchData = [];
    //   this.switchModal = true;
    //   this.switchGood = item;
    //   this.searchGoods();
    // },
    pageChange: function (page) {
      this.query.pageNo = page;
      this.searchGoods();
    },
    pageSizeChange: function (size) {
      this.query.pageSize = size;
      this.searchGoods();
    },
    searchGoods() {
      // 普通查询
      const sdata = {
        name: this.query.keyword || "",
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
      };
      if (!sdata.name) {
        this.choseGoods(this.switchGood, true);
      } else {
        // 其他查询商品
        goodsList(sdata).then((res) => {
          if (res.code == 0) {
            this.query.total = res.result.total;
            const switchData = res.result.records || [];
            switchData.map((z) => {
              z.price = z.marketPrice || z.collectivePrice;
              z.quantity = 1;
            });
            this.switchData = switchData;
          }
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirmSwitch() {
      const sdata = this.multipleSelection.map((z) => ({
        commodityId: z.id,
        shortageCommodityId: this.switchGood.commodityId,
        orderId: this.$route.query.id,
        unit: z.quantity,
        unitPrice: z.collectivePrice ? z.collectivePrice : z.marketPrice,
        discountPrice: z.collectivePrice ? z.collectivePrice : z.marketPrice,
      }));
      addCommodityRecommendToCommodityOrder(sdata).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.switchModal = false;
          this.getData();
          this.getOrderData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    removeGoods(item) {
      deleteCommodityRecommend({
        commodityId: item.commodityId,
        orderId: this.$route.query.id,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    exportExcel() {
      if (!this.tableData || this.tableData.length == 0) {
        return this.$message.warning("没有商品");
      }

      this.$prompt("请输入项目名称", "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "输入不能为空",
      })
        .then(({ value }) => {
          exportExcel({
            orderId: this.$route.query.id,
            name: value,
            userId: this.$store.state.user.info.id,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
      // exportExcel({
      //   orderId: this.$route.query.id,
      //   // ids: this.tableData.map(z => z.id).join(","),
      //   userId: this.$store.state.user.info.id
      // });
    },
    exportPPT() {
      if (!this.tableData || this.tableData.length == 0) {
        return this.$message.warning("没有商品");
      }
      this.$prompt("请输入项目名称", "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "输入不能为空",
      })
        .then(({ value }) => {
          exportPPT({
            orderId: this.$route.query.id,
            name: value,
            userId: this.$store.state.user.info.id,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
  },
};
</script>

<style lang="less" scoped>
.order-page {
  margin: auto;
  width: 80%;
  .status-box {
    margin-top: 10px;
    min-height: 90px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .first {
      float: left;
      width: 12%;
      padding: 20px 0px 10px 20px;
      h2 {
        margin-right: 60px;
        font-size: 24px;
        line-height: 60px;
        color: #ffa626;
      }
    }
    .second {
      float: left;
      width: 58%;
      padding: 20px 0px 10px 0px;
      > div:last-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .thrid {
      width: 22%;
      float: left;
      padding: 20px 0px 10px 0px;
      .img {
        width: 10%;
      }
      .customer {
        width: 10%;
        float: left;
        margin-left: 85px;
        margin-top: -70px;
        span {
          font-size: 12px;
          color: #81838e;
          white-space: nowrap;
          display: inline-block;
        }
      }
    }
  }

  .process-box {
    margin-top: 20px;
    padding: 20px 32px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    display: flex;
    > div:first-child p {
      font-size: 24px;
      line-height: 60px;
    }
    .img {
      width: 100px;
      text-align: center;
      // height: 100px;
      img {
        max-width: 100%;
      }
    }

    .process-content {
      margin-left: 20px;
      flex: 1;
      max-height: 400px;
      overflow: auto;
      .process {
        display: flex;
        min-height: 130px;
        > p:first-child {
          width: 120px;
          line-height: 20px;
          text-align: right;
        }
        &.suc .bar-box {
          i {
            color: #ffa626;
          }
          .bar {
            background: rgb(131, 197, 136);
          }
        }
        &:last-child .bar-box {
          .bar {
            display: none;
          }
        }
        .bar-box {
          position: relative;
          margin: 0 4px;
          i {
            position: relative;
            z-index: 1;
            font-size: 20px;
            // color: #ccc;
            color: rgb(131, 197, 136);
          }
          .bar {
            position: absolute;
            top: 16px;
            left: 0;
            right: 0;
            margin: auto;
            width: 4px;
            height: calc(100% - 16px);
            // background: #ccc;
            background: rgb(131, 197, 136);
          }
        }
        .txt {
          p {
            margin: 16px;
          }
        }
      }
    }
  }

  .info-box {
    margin-top: 20px;
    padding: 20px 32px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

    display: flex;
    justify-content: space-between;
    > div {
      padding: 20px;
      min-height: 160px;
      flex: 1;
      border-right: dashed 1px #ccc;
      > p:first-child {
        font-weight: bold;
      }
      p {
        display: flex;
        line-height: 24px;
        word-break: break-all;
        span:first-child {
          min-width: 100px;
        }
      }
    }
    .img {
      width: 200px;
      height: 100px;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
  .table {
    margin-top: 20px;
    padding: 20px 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .foot {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
